import apiService from './api/api.service';

class ProfileService {
  async getMyProfile() {
    return await apiService.get('/profile/me');
  }

  async updateProfile(data) {
    return await apiService.put('/profile', data);
  }

  async uploadProfilePicture(file) {
    const formData = new FormData();
    formData.append('profilePicture', file);

    return await apiService.put('/profile/picture', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  async getPublicProfile(userId) {
    return await apiService.get(`/profile/${userId}`);
  }

  async getMentors(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return await apiService.get(`/profile/mentors/list?${queryString}`);
  }
}

export default new ProfileService();
